import React, { useState } from "react";
import Dropzone from "react-dropzone";
import { Button, ImagePlus, ProgressBar } from "@opendate-app/setlist";
import ImageCropModal from "../../shared/ImageCropModal";
import { fileToDataUrl } from "../../shared/cropUtils";
import { toastError } from "../../shared/toastHelper";

const ASPECT_RATIO = 2;

const MembershipImageField = ({ imageUrl, fileName, uploadProgress, disabled, onImage, onRemove }) => {
  const [crop, setCrop] = useState(null);

  const startCrop = async (files) => {
    if (!files.length || disabled) return;
    try {
      setCrop({ src: await fileToDataUrl(files[0]), name: files[0].name });
    } catch {
      toastError("Failed to read image file. Please try again.");
    }
  };

  return (
    <div className="membership-field">
      <span className="membership-label">Membership image</span>
      <Dropzone maxFiles={1} accept="image/*" onDrop={startCrop} disabled={disabled} noClick={!!imageUrl} noKeyboard={!!imageUrl}>
        {({ getRootProps, getInputProps, open }) => (
          <div {...getRootProps({ className: `membership-image${imageUrl ? " has-image" : ""}` })}>
            <input {...getInputProps()} aria-label="Membership image" />
            {imageUrl ? (
              <>
                <img src={imageUrl} alt="" className="membership-image-thumb" />
                <div className="membership-image-meta">
                  <strong className="membership-image-name">{fileName || "Membership image"}</strong>
                  {uploadProgress ? (
                    <ProgressBar value={uploadProgress} label="bottom" />
                  ) : (
                    <span className="membership-hint">1200 × 600</span>
                  )}
                  <div className="membership-image-actions">
                    <Button variant="link-color" size="sm" disabled={disabled} onClick={() => setCrop({ src: imageUrl, name: fileName || "membership-image.jpg" })}>
                      Crop
                    </Button>
                    <Button variant="link-color" size="sm" disabled={disabled} onClick={open}>
                      Replace
                    </Button>
                    <Button variant="link-destructive" size="sm" disabled={disabled} onClick={onRemove}>
                      Remove
                    </Button>
                  </div>
                </div>
              </>
            ) : (
              <div className="membership-image-empty">
                <span className="membership-image-icon">
                  <ImagePlus width={20} height={20} aria-hidden="true" />
                </span>
                <span>
                  <strong className="membership-link-text">Upload image</strong> <span className="membership-hint">or drag and drop</span>
                  <br />
                  <span className="membership-hint">PNG, JPG, or GIF. 1200 × 600 (2:1).</span>
                </span>
              </div>
            )}
          </div>
        )}
      </Dropzone>
      <ImageCropModal
        open={!!crop}
        onClose={() => setCrop(null)}
        onCropComplete={(file) => {
          onImage(file);
          setCrop(null);
        }}
        imageSrc={crop ? crop.src : null}
        aspectRatio={ASPECT_RATIO}
        fileName={crop ? crop.name : "membership-image.jpg"}
      />
    </div>
  );
};

export default MembershipImageField;
